module.exports = __webpack_public_path__ + "assets/img/free_35.be042e4a.png";